import { useEffect, useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { apri, chiudi, idDallAncora } from '../../lib/ancora';
import { usePuo } from '../sessione/ContestoSessione';
import { NuovoSubappalto } from './NuovoSubappalto';
import { SchedaSubappalto } from './SchedaSubappalto';

const INTESTAZIONI: Record<string, string> = {
  VocePreventivo: 'Voce del preventivo',
  Fornitore: 'Impresa',
  DataInizio: 'Dal',
  DataFine: 'Al',
  DataOrdine: 'Aperto il',
};

/*  GLI ORDINI DI SUBAPPALTO, 16/10/2026. Sezione loro sotto Acquisti: un lavoro affidato
    a un'impresa — «fornitura e posa canalizzazioni, a corpo, 30.000» — non e' materiale
    da ricevere con una bolla. Ogni ordine sta su una commessa, e se la commessa viene da
    un preventivo e' legato alla voce che affida: l'elenco mostra tutte e due.  */
export function ElencoSubappalti() {
  const puoFare = usePuo();
  const [aperto, setAperto] = useState<string | null>(() => idDallAncora('subappalti'));
  const [creando, setCreando] = useState(false);
  const [versione, setVersione] = useState(0);

  useEffect(() => {
    const rileggi = () => {
      const id = idDallAncora('subappalti');
      if (id !== null) setAperto(id);
    };
    window.addEventListener('hashchange', rileggi);
    return () => window.removeEventListener('hashchange', rileggi);
  }, []);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Subappalti</h1>
            <p>
              I lavori affidati a un’impresa, commessa per commessa. Quando la commessa viene
              da un preventivo, l’ordine si apre dalla voce segnata «subappalto» e dice quanto
              si era preventivato; su una commessa aperta a mano si scrive libero.
            </p>
          </div>
          {puoFare('EmettiOrdini') && !creando && (
            <button type="button" className="primario" onClick={() => setCreando(true)}>
              Nuovo subappalto
            </button>
          )}
        </header>

        <DataGrid
          nomeGriglia="subappalti"
          versione={versione}
          colonneVisibili={[
            'Numero',
            'Sede',
            'Stato',
            'Commessa',
            'Cliente',
            'Preventivo',
            'VocePreventivo',
            'Fornitore',
            'Descrizione',
            'Importo',
            'DataInizio',
            'DataFine',
          ]}
          intestazioni={INTESTAZIONI}
          pastiglie={['Stato']}
          idSelezionato={aperto}
          onRigaSelezionata={(riga) => {
            const id = riga['Id'];
            if (typeof id !== 'string') return;
            setCreando(false);
            setAperto(id);
            apri('subappalti', id);
          }}
        />
      </div>

      {creando && (
        <NuovoSubappalto
          onAnnulla={() => setCreando(false)}
          onCreato={(id) => {
            setCreando(false);
            setAperto(id);
            apri('subappalti', id);
            setVersione((v) => v + 1);
          }}
        />
      )}

      {!creando && aperto && (
        <SchedaSubappalto
          subappaltoId={aperto}
          onChiudi={() => {
            setAperto(null);
            chiudi('subappalti');
          }}
          onCambiato={() => setVersione((v) => v + 1)}
        />
      )}
    </section>
  );
}
